export const OS_TYPES = {
  win: 'Windows',
  mac: 'Mac',
  linux: 'Linux',
  chromeOs: 'CrOS',
};
